export default {"src":"/_next/static/media/shopping.30515497.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};